var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRecursosAtivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4592 20.4219C38.8651 19.8646 37.9387 19.901 37.3144 20.4219L32.6624 24.2708C32.0914 24.7448 31.3807 25.0021 30.6486 25H24.6941C24.4805 25 24.2756 24.9122 24.1245 24.7559C23.9735 24.5996 23.8886 24.3877 23.8886 24.1667C23.8886 23.9457 23.9735 23.7337 24.1245 23.5774C24.2756 23.4211 24.4805 23.3333 24.6941 23.3333H28.6357C29.4363 23.3333 30.1819 22.7656 30.3098 21.9479C30.3255 21.854 30.3333 21.7589 30.3329 21.6635C30.3321 21.2221 30.162 20.7989 29.86 20.487C29.5579 20.1752 29.1486 20 28.7218 20H20.6665C19.3079 20.0004 17.9908 20.4838 16.9358 21.3693L14.5947 23.3333H11.8055C11.5919 23.3333 11.387 23.4211 11.2359 23.5774C11.0849 23.7337 11 23.9457 11 24.1667V29.1667C11 29.3877 11.0849 29.5996 11.2359 29.7559C11.387 29.9122 11.5919 30 11.8055 30H29.7675C30.4994 30.0006 31.2096 29.7434 31.7814 29.2708L39.3952 22.9688C39.5784 22.8172 39.7273 22.6261 39.8317 22.4088C39.9361 22.1916 39.9933 21.9533 39.9994 21.7108C40.0056 21.4683 39.9605 21.2273 39.8672 21.0046C39.774 20.782 39.6344 20.5831 39.4592 20.4219Z",
    fill: "#4D78AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecursosAtivo);
export default __webpack_public_path__ + "static/media/IconRecursosAtivo.bf1fc70339007b4bc929a964cb33a434.svg";
export { ForwardRef as ReactComponent };